import React from "react";
import styled, { css } from "styled-components";
const skeletonStyles = css`
  background: ${p => p.theme.colorCardBackground};
  border-radius: ${p => p.theme.borderRadius};
`;
const StyledWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  padding: 1.5rem 0 1rem 1.5rem;
  border-top-left-radius: ${p => p.theme.borderRadius};
  border-bottom-left-radius: ${p => p.theme.borderRadius};
  background-color: ${p => p.theme.colorTicketBackground};

  ${p => p.isSkeleton && skeletonStyles};
`;

const Wrapper = ({
  children,
  isSkeleton
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    isSkeleton: isSkeleton
  }, children);
};

export default Wrapper;